export default __webpack_public_path__ + "images/c19cbdc5905ade49fabb76794c60edf4-country_music.jpg";